import './math';
import './ternary';

import { Aux } from '../../../AuxillaryService';
import '../../extendBuiltIns/Date.prototype.format';
import Handlebars from 'handlebars';
import { HandlebarsComparator, HandlebarsOperator, HandlebarsContext } from './types';
import { Log } from '../../../AuxillaryService/Log';
import { DateExtended } from '../../extendBuiltIns/types';
import { HandlebarsHelperOptions } from '../types';

/* custom register helpers */

//NOTE -- The Handlebars documentation does not offer enough information,
// so explicit any has been disabled for this file
/* eslint-disable @typescript-eslint/no-explicit-any */

Handlebars.registerHelper(
    'ifCond',
    function (
        this: HandlebarsContext,
        v1: any,
        operator: HandlebarsComparator,
        v2: any,
        options: HandlebarsHelperOptions
    ): string {
        switch (operator) {
            case '==':
                return v1 == v2 ? options.fn(this) : options.inverse(this);
            case '!=':
                return v1 != v2 ? options.fn(this) : options.inverse(this);
            case '===':
                return v1 === v2 ? options.fn(this) : options.inverse(this);
            case '<':
                return v1 < v2 ? options.fn(this) : options.inverse(this);
            case '<=':
                return v1 <= v2 ? options.fn(this) : options.inverse(this);
            case '>':
                return v1 > v2 ? options.fn(this) : options.inverse(this);
            case '>=':
                return v1 >= v2 ? options.fn(this) : options.inverse(this);
            case '&&':
                return v1 && v2 ? options.fn(this) : options.inverse(this);
            case '||':
                return v1 || v2 ? options.fn(this) : options.inverse(this);
            default:
                return options.inverse(this);
        }
    }
);

Handlebars.registerHelper('Global', function (v1: any, options: HandlebarsHelperOptions): unknown {
    return options.data.root.viewBag[v1];
});

Handlebars.registerHelper('Date', function (d: DateExtended, f: string): string {
    return d.format(f);
});

Handlebars.registerHelper('Image', function (i: string): string {
    return Aux.Service('ImageCache').getImage(i);
});

Handlebars.registerHelper(
    'GetImageFromCache',
    function (origURL: string, elemPrefix: string, elemId: string): string {
        return `<script>
                $(function() {
                    const e = $('.${elemPrefix}${elemId}');

                    Aux.Service('ImageCache').getImage('${origURL}')
                        .then(function(dataURL) {
                            e.attr('src', dataURL);
                        }).catch(function() {
                            e.attr('src', '${origURL}');
                        })
                        .always(function() {
                            e.show();
                        });
                });
            </script>`;
    }
);

Handlebars.registerHelper(
    'GetImageFromCacheEx',
    function (origURL: string, elemPrefix: string, elemId: string, elemSuffix: string): string {
        return `<script>
                $(function() {
                    const e = $('.${elemPrefix}${elemId}_${elemSuffix}');

                    Aux.Service('ImageCache').getImage('${origURL}')
                        .then(function(dataURL) {
                            e.attr('src', dataURL);
                        }).catch(function() {
                            e.attr('src', '${origURL}');
                        })
                        .always(function() {
                            e.show();
                        });
                });
            </script>`;
    }
);

Handlebars.registerHelper(
    'GetBackgroundImageFromCache',
    function (origURL: string, elemPrefix: string, elemId: string): string {
        return `<script>
                $(function() {
                    const e = $('.${elemPrefix}${elemId}');

                    Aux.Service('ImageCache').getImage('${origURL}')
                        .then(function(dataURL) {
                            e.css('background-image', 'url(' + dataURL + ')');
                        }).catch(function() {
                            e.css('background-image', 'url(${origURL})');
                        })
                        .always(function() {
                            e.show();
                        });
                });
            </script>`;
    }
);

/**
 * @deprecated
 * Handlebars has a built in logger
 */
Handlebars.registerHelper('ConsoleLog', function (item: unknown): void {
    console.log(item);
});

Handlebars.registerHelper('FilterMessage', function (msg: string): string {
    return msg ? msg.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '') : '';
});

Handlebars.registerHelper(
    'Switch',
    function (this: HandlebarsContext, v1: unknown, options: HandlebarsHelperOptions): string {
        /* eslint-disable @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        window['handlebars_switch_v'] = v1;
        // @ts-ignore
        window['handlebars_switch_m'] = false;
        /* eslint-enable @typescript-eslint/ban-ts-comment */

        return options.fn(this);
    }
);

Handlebars.registerHelper('Case', function (v1: unknown, options: HandlebarsHelperOptions): string {
    /* eslint-disable @typescript-eslint/ban-ts-comment */
    // @ts-ignore
    const r = window['handlebars_switch_v'] == v1 ? options.fn(this) : options.inverse(this);
    // @ts-ignore
    window['handlebars_switch_m'] = window['handlebars_switch_m'] || r;
    /* eslint-enable @typescript-eslint/ban-ts-comment */

    return r;
});

Handlebars.registerHelper('Default', function (options: HandlebarsHelperOptions): string {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return window['handlebars_switch_m'] == false ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper(
    'str_replace',
    function (needle: string, replacement: string, haystack: string): string {
        return haystack.replace(needle, replacement);
    }
);

Handlebars.registerHelper('escape', function (str: string): string {
    return Handlebars.Utils.escapeExpression(str);
});

/**
 * @deprecated
 * Use 'Math' helper instead
 */
Handlebars.registerHelper('math', function (left: number, op: HandlebarsOperator, right: number):
    | number
    | undefined {
    switch (op) {
        case '+':
            return left + right;
        case '-':
            return left - right;
        case '/':
            return left / right;
        case '*':
            return left * right;
        default:
            Log.Warning(`Invalid handlebars math operator: ${op}`, null, __fileline);
            return undefined;
    }
});
